import { render, staticRenderFns } from "./ReturnPost.vue?vue&type=template&id=1ffdb64a"
import script from "./ReturnPost.vue?vue&type=script&lang=js"
export * from "./ReturnPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports